<template>
    <v-row>
      <v-spacer></v-spacer>
      <v-col
         cols="12"
          md="3"
      >
        <v-text-field
          label="Länge"
          suffix="m"
          name="bldg-length"
          v-model.number="bldgLength"
          inputmode="decimal"
          type="number"
          min="0"
          dense
        />
      </v-col>

      <v-col
      cols="12"
      md="3"
      >
        <v-text-field
          label="Breite"
          suffix="m"
          name="bldg-width"
          v-model.number="bldgWidth"
          inputmode="decimal"
          type="number"
          min="0"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          readonly
          :value="bldgAreaDisplay"
          label="Fläche"
          suffix="m²"
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
         <v-btn
            icon
            :disabled="disableDeleteButton"
            @click="$emit('delete-item')"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            v-if="showAddButton"
            icon
            @click="$emit('add-item')"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
      </v-col>
    </v-row>
</template>

<script>
/**
 * UI element to enter width and length of a part of the building
 */
export default {
  props: {
    disableDeleteButton: { default: false },
    showAddButton: { default: false },
    defaultLength: {default: 7},
    defaultWidth: {default: 10}
  },
  data () {
    return {
      bldgLength: 7,
      bldgWidth: 10
    }
  },
  created() {
    this.bldgLength = this.defaultLength;
    this.bldgWidth = this.defaultWidth;
  },
  computed: {
    bldgArea () {
      return (this.bldgLength * this.bldgWidth).toFixed(2);
    },
    bldgAreaDisplay () {
      return new Intl.NumberFormat('de-DE').format(this.bldgArea)
    }
  },
  watch:
  {
    bldgArea: {
      immediate: true,
      handler (newVal, oldVal) {
        // this check is mandatory to prevent endless cycle
        if (newVal !== oldVal) {
          this.$emit('area-change', newVal);
        }
      },
    }
  },
}
</script>
